import { ActionType } from "../../model/enum/ActionType";
import { ActionResponseValue, MedicineActionResponse } from "../../model/actions/ActionResponse";

export const isMedicineAction = (candidate?: ActionResponseValue): candidate is MedicineActionResponse => {
  return !!candidate && candidate.type === ActionType.Medicine;
};
